<div class="chip-control" [ngClass]="config.class">
  @if (config?.options?.length > 0) {
    <label class="default-sub-header text-label"
    for="">{{config.label | translate}}</label>
  }
  <mat-chip-listbox class="chip-control__chip-view" [multiple]="multiple">
    @for (chipItem of config.options; track chipItem; let i = $index) {
      <mat-chip-option
      [ngStyle]="{'border-color': chipItem.color, 'color': chipItem.setSelected ? '' : chipItem.color,
          'background-color': chipItem.setSelected ? chipItem.color : '' }"
        [title]="chipItem.Value" [disabled]="chipItem.isDisabled"
        class="chip-control__chips" [selected]="chipItem.setSelected" (click)="selectedChip(i)"
        [ngClass]="{'chip-control__selected-chip':chipItem.setSelected}">
        @if (chipItem.Icon !== 'None') {
          <div matTooltipClass="tooltip-class" title="{{chipItem.toolTipData}}">
            <i [ngStyle]="{'color': chipItem.setSelected ? '' : chipItem.color}"
            class="chip-control__chip-icon icon-{{chipItem.Icon ? chipItem.Icon : 'Default'}}"></i>&nbsp;
            <span>{{chipItem.Name}}</span>
          </div>
        }
        @if (chipItem.Icon == 'None') {
          <div matTooltipClass="tooltip-class" title="{{chipItem.toolTipData}}">
            <span>{{chipItem.Name}}</span>
          </div>
        }
      </mat-chip-option>
    }
  </mat-chip-listbox>
</div>
